export enum ItemStateEnum {
  New = '1',
  Accepted = '2'
}